<template>
	<b-container class="overlay" :class="containerclass">
		<b-row align-v="center" class="vh-100">
			<b-col>
				<b-card style="width:26rem" class="mx-auto bg-none border-none my-auto">
					<b-form>
						<p>
							{{ $t("setup2fa.info-text") }}
						</p>
						<p class="text-danger">
							{{ errortext }}
						</p>
						<b-form-group :label="$t('setup2fa.label-text')" label-for="login">
							<VuePhoneNumberInput v-model="form.phone" @update="phoneNumberUpdated" />
						</b-form-group>
						<b-form-group>
							<b-button
								variant="primary"
								block
								@click="submit"
							>
								{{ $t("setup2fa.button-text") }}
							</b-button>
						</b-form-group>
						<b-form-group>
							<div class="text-center link" @click="hide">
								{{ $t("setup2fa.back-link") }}
							</div>
						</b-form-group>
					</b-form>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	name: 'Setup2FA',
	props: {
		callback: {
			type: Function,
			required: true,
		},
	},
	data: () => ({
		form: {
			phone: '',
			phoneInternational: '',
			phoneValid: false,
		},
		containerclass: 'hidden',
		errortext: '',
	}),
	methods: {
		submit() {
			if (this.form.phoneValid) {
				this.callback(this.form.phoneInternational);
			} else {
				this.errortext = this.$t('setup2fa.number-invalid');
			}
		},
		show() {
			this.errortext = '';
			this.containerclass = `${this.$store.state.bg_class}`;
		},
		hide() {
			this.containerclass = `hidden ${this.$store.state.bg_class}`;
		},
		phoneNumberUpdated(event) {
			this.form.phoneValid = event.isValid;
			if (event.isValid) {
				this.form.phoneInternational = event.formatInternational.replaceAll(/[+ ]/g, '');
			}
		},
	},
};
</script>
